import { gql } from '@apollo/client';

export const DELETE_CHECKLISTS = gql`
  mutation deleteChecklists($input: DeleteChecklistsInput) {
    deleteChecklists(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_CHECKLISTS_LIST = gql`
  mutation exportChecklistList($filters: ExportChecklistsListInput) {
    exportChecklistList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
